import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChange } from '@angular/core';
import { Router } from '@angular/router';
import { MouseEvent } from '@agm/core';
import { GooglemapService, LocationInfo, MarkerInfo } from './googlemap.service';
import { Observable } from 'rxjs/Observable';
import { CarService, Car } from '../member-kanri/car.service';
import { AppConstants, LOGON_INFO } from '../app.constants';
import { MessageService } from './message.service';
import $ from 'jquery';

declare let google: any;


@Component({
    selector: 'app-googlemap',
    templateUrl: 'googlemap.component.html',
    providers: [GooglemapService, CarService]
})
export class GooglemapComponent implements OnInit {

    searchText: string;
    zipcode: string;
    todohuken: string;
    address: string;
    errorMsg: string;
    m_lat: number;
    m_lng: number;
    protected modalMap: any;
    protected cargoMap: any;
    locationInfo: LocationInfo;

    distDura: string;

    //map初期設定
    streetViewControl: boolean = false;
    disableDoubleClickZoom: boolean = true;

    lat: number;
    lng: number;

    //carList: Car[];

    @Input()
    zoom: number = 8;

    @Input()
    maptype: string;

    @Input()
    selCar: Car;

    @Input()
    origin: any;
    @Input()
    destination: any;

    @Output()
    selectAddress = new EventEmitter<LocationInfo>();

    @Output()
    selectCar = new EventEmitter<Car>();

    constructor(
        public mapService: GooglemapService,
        private msgService: MessageService,
        private router: Router,
        private carService: CarService
    ) {  }


    //初期表示時のメソッド呼出順：ngOnChanges() ⇒ ngOnInit() ⇒ directionMapReady()

    ngOnInit() {
        let hsize = $(window).height();
        
        this.lat = LOGON_INFO.COMP_LAT && LOGON_INFO.COMP_LAT!="null" ? +LOGON_INFO.COMP_LAT : AppConstants.BASIC_LAT;
        this.lng = LOGON_INFO.COMP_LNG && LOGON_INFO.COMP_LNG!="null" ? +LOGON_INFO.COMP_LNG : AppConstants.BASIC_LNG;

        //積み地・卸し地の選択用の地図の場合
        if (this.maptype == 'modal') {
            //住所選択modal地図の縦サイズを画面サイズに合わせて初期設定
            $(document).ready(function () {
                $("#modalMap").css("height", (hsize/2) + "px");
            });
        }
        //車両位置、経路表示用の地図の場合
        else {  
            //車両位置照会メニューの場合
            if (this.router.url === "/map") {
                this.carService.fetchAllCarList()
                    .then( data => this.mapService.carList = data )
                    .catch( error => this.mapService.carList = [] );
                
                //地図の縦サイズを画面全体とする
                $(document).ready(function () {
                    $("#cargoMap").css("height", (hsize-100)+"px");
                });
            }
            //経路表示地図の場合
            else {
                this.mapService.carList = this.carService.getAllCarList();

                //貨物位置地図の縦サイズを画面サイズに合わせて初期設定
                $(document).ready(function () {
                    $("#cargoMap").css("height", "30rem");
                });
            }
        }
    }


    ngOnChanges(changes: {[key: string]: SimpleChange}): void {

        //積み地or卸し地が変更された場合
        if ((changes['origin'] && !changes['origin'].firstChange) || (changes['destination'] && !changes['destination'].firstChange)) {
            this.mapService.drawDirection(this.cargoMap, this.origin, this.destination)
                .then( data => this.distDura = data )
                .catch( error => this.distDura = "" );
        }

        //配車車両が変更された場合
        if (changes['selCar'] && !changes['selCar'].firstChange) {
            //infoWindowを全部閉じる
            for(var i=0; i<this.mapService.carInfoWindow.length; i++) {
                this.mapService.carInfoWindow[i].close();
            }

            //選択車両がある場合
            if (this.selCar && this.selCar.id) {
                //貨物登録画面の場合
                if (this.router.url == "/cargo/client") {
                    //選択車両のみ、マーカ・infowindowを表示する
                    this.mapService.createCarMarker(this.cargoMap, [this.selCar], true);
                }
                //配車管理画面の場合
                else if (this.router.url == "/cargo/transport") {
                    //選択車両のinfowindowを表示する
                    let i = this.mapService.carList.findIndex(({id})=>id===this.selCar.id);
                    this.mapService.openInfoWindow(this.cargoMap, i);
                }
            }
            //車両選択が解除された場合
            else {
                if (this.router.url == "/cargo/transport") {
                    //全車両のマーカを再表示する
                    this.mapService.createCarMarker(this.cargoMap, this.mapService.carList, false);
                }
                else if (this.router.url == "/cargo/client") {
                    this.mapService.clearCarMarker();
                }
            }
        }
    }



    protected modalMapReady(map) {
        this.modalMap = map;

        //クリック場所の情報表示POPUPを無視する
        var set = google.maps.InfoWindow.prototype.set;
	    google.maps.InfoWindow.prototype.set = function(key, val) {
		    if (key === "map") {
			    if (! this.get("noSuppress")) {
				    return;
			    }
		    }
		    set.apply(this, arguments);
	    }
    }

    protected directionMapReady(map) {
        this.cargoMap = map;

        //クリック場所の情報表示POPUPを無視する
        var set = google.maps.InfoWindow.prototype.set;
	    google.maps.InfoWindow.prototype.set = function(key, val) {
		    if (key === "map") {
			    if (! this.get("noSuppress")) {
				    return;
			    }
		    }
		    set.apply(this, arguments);
        }

        if (this.router.url != "/cargo/client") {
            let mapInterval = setInterval(() => {
                if (this.mapService.carList) {
                    clearInterval(mapInterval);
                    this.mapService.createCarMarker(map, this.mapService.carList, false);
                }
            }, 100);
        }
    }


    mapClicked($event: MouseEvent) {
        this.m_lat = $event.coords.lat;
        this.m_lng = $event.coords.lng;
        this.mapService.getAddressFromLatLng(this.m_lat, this.m_lng)
        .then(
            (data) => {
                this.zipcode = data.zipcode;
                this.todohuken = data.todohuken;
                this.address = data.address;
                this.errorMsg = "";
            }
        )
        .catch(
            (error) => this.errorMsg = error
        );
    }


    closeModal(): void {
        this.zipcode = "";
        this.todohuken = "";
        this.address = "";
        this.searchText = "";
        this.m_lat = null;
        this.m_lng = null;
        this.modalMap.setCenter({lat: this.lat, lng: this.lng});
    }

    onSelect(): void {
        this.selectAddress.emit(new LocationInfo(this.m_lat, this.m_lng, this.zipcode, this.todohuken, this.address));
        this.closeModal();
        $('#mapModal').modal('hide');
    }


    search() {
        this.searchText = this.searchText.trim();
        if (this.searchText.length >= 2) {
            this.mapService.getLatLngFromSearch(this.searchText)
            .then(
                (data) => {
                    this.m_lat = data.lat();
                    this.m_lng = data.lng();
                    this.modalMap.setCenter(data);
                    this.modalMap.setZoom(14);
                    this.mapService.getAddressFromLatLng(this.m_lat, this.m_lng)
                        .then(
                            (data) => {
                                this.zipcode = data.zipcode;
                                this.address = data.address;
                                this.todohuken = data.todohuken;
                                this.errorMsg = "";
                            }
                        )
                        .catch(
                            (error) => this.errorMsg = error
                        );
                }
            )
            .catch(
                (error) => this.errorMsg = error
            );
        }
        else {
            this.msgService.addError("２桁以上の文字列を入力してください。");
        }
    }


    searchKeyDown(event) {
        //エンターキー押下
        if (event.keyCode == 13) {
            this.search();
        }
    }


    changeHandler(event: any) {
        console.log(event);
    }

}


// WEBPACK FOOTER //
// ./src/app/common/googlemap.component.ts